<form class="grid mt-0 mb-6 p-fluid" [formGroup]="form">
    <div class="linha col-6">
      <span class="p-float-label">
        <input pInputText formControlName="name" id="nome-completo" class="w-full" />
        <label class="pl-1 h-1rem flex align-items-center" for="cpf">Nome do Serviço <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
          alt="alerta-campo-vazio" /></label>
      </span>
    </div>
     <div class="col-6">
      <span class="p-float-label">
        <p-multiSelect
              inputId="multiselect"
              [options]="professionalUnits"
              formControlName="units"
              optionLabel="unitName"
              optionValue="@id"
              [filter]="true"
              [filterBy]="'unitName'"
            ></p-multiSelect>
            <label class="pl-1 h-1rem flex align-items-center" for="cpf">Unidades <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
              alt="alerta-campo-vazio" /></label>
      </span>
    </div> 
    <div class="col-12 mt-3" [ngClass]="especialidadeLista.length > 0? '' : 'inativo'">
      <span class="p-float-label">
        <p-dropdown
          formControlName="specialty"
          [options]="especialidadeLista"
          optionLabel="name"
          optionValue="@id"
          [filter]="true" 
          filterBy="name"
        ></p-dropdown>
        <label class="pl-1 h-1rem flex align-items-center" for="cpf">Especialidade
           <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
          alt="alerta-campo-vazio" /> 
        </label>
      </span>
    </div>

    <div class="linha col-12 mt-3">
      <span class="p-float-label">
        <input pInputText formControlName="observation" class="w-full" />
        <label htmlFor="nome-completo">Observações </label>
      </span>
    </div>
    
    <div class="col-3 mt-3">
      <span class="p-float-label">
        <p-inputNumber formControlName="value" (onInput)="calculaTotalRepasse()" prefix="R$ " [showButtons]="false" inputId="stacked" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber>
        <label class="pl-1 h-1rem flex align-items-center" for="cpf">Valor <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
          alt="alerta-campo-vazio" /></label>
      </span>
    </div>
    <div class="col-5 mt-3">
      <div class="p-inputgroup" id="repasse-tipo">
          <span class="p-float-label">
            <p-inputNumber formControlName="payout" (onInput)="calculaTotalRepasse()" *ngIf="form.value.valueType == '%'" inputId="percent" suffix="%"> </p-inputNumber>
            <p-inputNumber formControlName="payout" (onInput)="calculaTotalRepasse()" *ngIf="form.value.valueType != '%'" prefix="R$ " [showButtons]="false" inputId="stacked" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber>

            <label class="pl-1 h-1rem flex align-items-center" for="cpf">Repasse <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
              alt="alerta-campo-vazio" /></label>
          </span>
          <p-selectButton formControlName="valueType" [options]="repasseTipoOptions" (onChange)="calculaTotalRepasseHandler()" optionLabel="label" optionValue="value"></p-selectButton>
      </div>
    </div>
    
    <div class="col-4 mt-3">
      <span class="p-float-label disabled">
        <p-inputNumber [readonly]="true" formControlName="totalPayout" prefix="R$ " [showButtons]="false" inputId="stacked" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber>
        <label for="inputnumber">Total Repasse (R$)</label>
      </span>
    </div>
    
  </form>
